
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 112 91","fill":"#fff","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M111.273 37.87L77.308.772 25.556 90.407l26.785-17.2 21.333-39.641-15.886 37.086 20.588-12.618 15.99-30.013L82.623 55.43l28.649-17.56zM35.286 17.815V.315l19.484 33.75L74.29.257.163.255v17.561c0 9.7 7.863 17.562 17.561 17.562 9.7-.001 17.562-7.864 17.562-17.563z"}})])
          )
        }
      }
    